<template>
  <DataListStateful
    title="Единицы измерения"
    resource="units"
    store="units"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        {
          title: "Наименование",
          name: "title",
          dataPath: "Title",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
      },
    };
  },
};
</script>
